import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20luxurious%20background%20with%20flowing%20golden%20and%20amber%20light%20streaks%2C%20geometric%20shapes%20with%20soft%20glow%2C%20elegant%20gaming%20atmosphere%2C%20premium%20dark%20texture%20with%20warm%20highlights%2C%20cinematic%20composition%2C%20no%20people&width=1920&height=800&seq=cta-bg-jiuyou&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/75 to-foreground-950/85"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            准备好了吗？开启你的游戏之旅
          </h2>
          <p className="text-background-100/70 text-sm md:text-base mb-8 max-w-xl mx-auto">
            立即加入九游娱乐，800万玩家的共同选择。新人注册即享丰厚豪礼，
            海量精品游戏等你探索！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="w-full sm:w-auto px-10 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              免费注册 · 领新人礼包
            </a>
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              探索游戏大厅
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10 pt-8 border-t border-background-50/15">
            <div className="flex items-center gap-2 text-background-100/60 text-xs">
              <i className="ri-shield-check-line text-accent-400 text-sm"></i>
              <span>官方正版授权</span>
            </div>
            <div className="flex items-center gap-2 text-background-100/60 text-xs">
              <i className="ri-lock-line text-accent-400 text-sm"></i>
              <span>数据加密传输</span>
            </div>
            <div className="flex items-center gap-2 text-background-100/60 text-xs">
              <i className="ri-bank-card-line text-accent-400 text-sm"></i>
              <span>资金安全保障</span>
            </div>
            <div className="flex items-center gap-2 text-background-100/60 text-xs">
              <i className="ri-customer-service-line text-accent-400 text-sm"></i>
              <span>全天候客服支持</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}